export default __webpack_public_path__ + "static/media/vodafone.1ae2e682.jpg";